module.exports = __webpack_public_path__ + "assets/842656d253676a26069ac1020e48bd41.mp3";